import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.25 12C2.25 6.61522 6.61522 2.25 12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12ZM12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C16.5563 20.25 20.25 16.5563 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M14.1015 14.975C13.8689 14.9754 13.6457 14.8833 13.4813 14.7188C13.3168 14.5543 13.2246 14.3311 13.2251 14.0985C13.2258 13.6159 13.6173 13.2249 14.1002 13.2249C14.5834 13.2249 14.9752 13.6166 14.9752 14.0999C14.9752 14.5827 14.5842 14.9742 14.1015 14.975Z"
    }, null, -1),
    _createElementVNode("path", { d: "M9.25616 10.4938C9.42064 10.6583 9.64385 10.7505 9.87641 10.75C10.3591 10.7492 10.7501 10.3578 10.7501 9.87493C10.7501 9.39165 10.3583 8.99988 9.87505 8.99988C9.39223 8.99988 9.00075 9.39091 9 9.87354C8.99951 10.1061 9.09168 10.3293 9.25616 10.4938Z" }, null, -1),
    _createElementVNode("path", { d: "M14.531 10.5301C14.8239 10.2372 14.8239 9.76232 14.531 9.46943C14.2381 9.17653 13.7633 9.17653 13.4704 9.46943L9.46869 13.4711C9.1758 13.764 9.1758 14.2389 9.46869 14.5318C9.76159 14.8246 10.2365 14.8246 10.5294 14.5318L14.531 10.5301Z" }, null, -1)
  ])))
}
export default { render: render }